import { dispatchCustomEvent, dispatchErrorEvent } from './event'
import { type CatchError, getErrorMessage } from '../../lib/functional/error.no-deps'
import { consoleError } from '../../lib/functional/console.no-deps'

/**
 * Wrapper for attribute change callbacks that reports error
 */
export async function onAttributeChange(
    element: HTMLElement,
    name: string,
    oldValue: string | boolean,
    newValue: string | boolean,
    onChange: () => void | Promise<void>
) {
    if (oldValue === newValue) return

    try {
        await onChange()
        dispatchCustomEvent(element, 'attributeChanged', { name, oldValue, newValue })
    } catch (catchError) {
        const error = new AttributeChangeError(name, oldValue, newValue, catchError)
        dispatchErrorEvent(element, 'attributeChangedError', error)
        element.removeAttribute(name)
        consoleError(error)
    }
}

export class AttributeChangeError extends Error {
    constructor(
        public name: string,
        public oldValue: unknown,
        public newValue: unknown,
        public catchError: CatchError
    ) {
        super(`Error trying to change ${name} from ${oldValue} to ${newValue}: ${getErrorMessage(catchError)}`)
    }
}
